var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartsTab1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0361 1H3.03613C2.5057 1 1.99699 1.21071 1.62192 1.58579C1.24685 1.96086 1.03613 2.46957 1.03613 3V25C1.03613 25.5304 1.24685 26.0391 1.62192 26.4142C1.99699 26.7893 2.5057 27 3.03613 27H21.0361C21.5666 27 22.0753 26.7893 22.4503 26.4142C22.8254 26.0391 23.0361 25.5304 23.0361 25V3C23.0361 2.46957 22.8254 1.96086 22.4503 1.58579C22.0753 1.21071 21.5666 1 21.0361 1Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9541 18H16.2721C14.8021 18 13.3521 17.658 12.0361 17C10.7218 16.3399 9.27092 15.9973 7.80013 16H6.12013M1.03613 7H23.0361M18.0361 17C18.0361 17.7879 17.8809 18.5681 17.5794 19.2961C17.2779 20.0241 16.8359 20.6855 16.2788 21.2426C15.7216 21.7998 15.0602 22.2417 14.3322 22.5433C13.6043 22.8448 12.8241 23 12.0361 23C11.2482 23 10.468 22.8448 9.74003 22.5433C9.01208 22.2417 8.35064 21.7998 7.79349 21.2426C7.23634 20.6855 6.79438 20.0241 6.49286 19.2961C6.19133 18.5681 6.03613 17.7879 6.03613 17C6.03613 15.4087 6.66827 13.8826 7.79349 12.7574C8.91871 11.6321 10.4448 11 12.0361 11C13.6274 11 15.1536 11.6321 16.2788 12.7574C17.404 13.8826 18.0361 15.4087 18.0361 17Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartsTab1);
export default __webpack_public_path__ + "static/media/parts-tab-1.174027a621f55576af0d3feaef03be5b.svg";
export { ForwardRef as ReactComponent };